import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { SessionDetails } from "./Types/SessionDetails";
import { mountStoreDevtool } from "simple-zustand-devtools";
import { AppData } from "./Types/AppData";

interface Token {
  access_token: string;
}

export const enum SidebarOption {
  CdrReady= "cdrready"
}

interface IStore {
  access: any;
  setAccess: (access: any) => void;
  token: Token | null;
  setToken: (token: Token | null) => void;
  sessionDetails: SessionDetails | null;
  setSessionDetails: (sessionDetails: SessionDetails | null) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  isEmbedded: boolean;
  setIsEmbedded: (isEmbedded: boolean) => void;
  showPopup: boolean;
  setShowPopup: (showPopup: boolean) => void;
  showPopupError: boolean;
  setShowPopupError: (showPopupError: boolean) => void;
  popupErrorMessage: string;
  setPopupErrorMessage: (popupErrorMessage: string) => void;
  data: AppData | null;
  setData: (data: AppData | null) => void;
  selectedDataHolder: any;
  setSelectedDataHolder: (selectedDataHolder: any) => void;
  selectedConsent: any;
  setSelectedConsent: (selectedConsent: any) => void;
  selectedDataHolderBrand: any;
  setSelectedDataHolderBrand: (selectedDataHolderBrand: any) => void;
  selectedCustomer: any;
  setSelectedCustomer: (selectedCustomer: any) => void;
  redirecting: boolean;
  setRedirecting: (redirecting: boolean) => void;
  sidebarDisplay?: SidebarOption | null
  setSidebarDisplay: (sidebarDisplay: SidebarOption) => void;
}

export const useStore = create<IStore>()(
  // State is persisted, so we have it when we come back from a redirect
  persist(
    (set) => ({
      isEmbedded: false,
      setIsEmbedded: (isEmbedded: boolean) =>
        set((state) => ({ ...state, isEmbedded })),

      access: false,
      setAccess: (access: any) => set((state) => ({ ...state, access })),

      token: null,
      setToken: (token: Token | null) => set((state) => ({ ...state, token })),

      sessionDetails: null,
      setSessionDetails: (sessionDetails: SessionDetails | null) =>
        set((state) => ({ ...state, sessionDetails })),

      loading: false,
      setLoading: (loading: boolean) => set((state) => ({ ...state, loading })),

      showPopup: false,
      setShowPopup: (showPopup: boolean) =>
        set((state) => ({ ...state, showPopup })),

      showPopupError: false,
      setShowPopupError: (showPopupError: boolean) =>
        set((state) => ({ ...state, showPopupError })),

      popupErrorMessage: "",
      setPopupErrorMessage: (popupErrorMessage: string) =>
        set((state) => ({ ...state, popupErrorMessage })),

      selectedDataHolder: null,
      setSelectedDataHolder: (selectedDataHolder: any) =>
        set((state) => ({ ...state, selectedDataHolder })),

      selectedDataHolderBrand: null,
      setSelectedDataHolderBrand: (selectedDataHolderBrand: any) =>
        set((state) => ({ ...state, selectedDataHolderBrand })),

      selectedCustomer: null,
      setSelectedCustomer: (selectedCustomer: any) =>
        set((state) => ({ ...state, selectedCustomer })),

      selectedConsent: null,
      setSelectedConsent: (selectedConsent: any) =>
        set((state) => ({ ...state, selectedConsent })),

      data: null,
      setData: (data: AppData | null) => set((state) => ({ ...state, data })),

      redirecting: false,
      setRedirecting: (redirecting: boolean) =>
        set((state) => ({ ...state, redirecting })),

      sidebarDisplay: null,
      setSidebarDisplay: (sidebarDisplay: SidebarOption) =>
        set((state) => ({ ...state, sidebarDisplay })),
    }),
    {
      name: process.env.REACT_APP_ENV + "ConsentSessionStore", // unique name
      storage: createJSONStorage(() => sessionStorage), // (optional) by default the 'localStorage' is used. But Don't use localStorage!!!!! It's not secure.
    }
  )
);

if (process.env.NODE_ENV === "development") {
  mountStoreDevtool(
    process.env.REACT_APP_ENV + "ConsentSessionStore",
    useStore
  );
}
